import React, { useCallback, useEffect, useState } from 'react';
import { useTransition } from 'react-spring';

import Toast from './Toast';
import { Container } from './style';
import { ToastMessage } from '~/services/hooks/toast';

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer = ({ messages }: ToastContainerProps) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  const listenToScroll = useCallback(() => {
    setScrollPosition(window.pageYOffset);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);

    return () => window.removeEventListener('scroll', listenToScroll);
  }, [listenToScroll]);

  const messagesWithTransitions = useTransition(messages, message => message.id, {
    from: { right: '-120%', opacity: 0 },
    enter: { right: '0%', opacity: 1 },
    leave: { right: '-120%', opacity: 0 },
  });

  return (
    <Container topScroll={scrollPosition}>
      {messagesWithTransitions.map(({ item, key, props }) => (
        <Toast key={key} style={props} message={item} />
      ))}
    </Container>
  );
};

export { ToastContainer };
